export default __webpack_public_path__ + "static/media/2324 knife block A top.2dea56e9.png";